import api from "./api";

export const productsService = {
  // Get all products
  getAllProducts: async (
    category = null,
    network = null,
    status = "active",
  ) => {
    const params = new URLSearchParams();
    if (category) params.append("category", category);
    if (network) params.append("network", network);
    if (status) params.append("status", status);
    const response = await api.get(`/products?${params.toString()}`);
    return response.data;
  },

  // Get affordable data products (internal)
  getAffordableDataProducts: async (network = null) => {
    const params = network ? `?network=${network}` : "";
    const response = await api.get(`/products/affordable-data${params}`);
    return response.data;
  },

  // Get airtime & data products (external, disguised as internal)
  getAirtimeDataProducts: async (network = null) => {
    const params = network ? `?network=${network}` : "";
    const response = await api.get(`/products/airtime-data${params}`);
    return response.data;
  },

  // UNIFIED purchase method - handles both internal and external
  purchaseProduct: async (purchaseData) => {
    const response = await api.post("/products/purchase", purchaseData);
    return response.data;
  },

  // Get product by ID
  getProductById: async (productId) => {
    const response = await api.get(`/products/${productId}`);
    return response.data;
  },

  // Get networks
  getNetworks: async (category = null) => {
    const params = category ? `?category=${category}` : "";
    const response = await api.get(`/products/networks${params}`);
    return response.data;
  },
};
